import MembersTable from 'trunks/vue/admin/compositions/datable_table/members_table.js';
import UserOrganizationsContainer from 'trunks/vue/admin/components/organizations/users_organizations_container.js';
import OrganizationsContent from 'trunks/vue/admin/components/organizations/organizations_content.js';

const SPEACIAL_FIELDS = [
  {
    id: -1,
    title: '姓名',
    type: 'Field::UserItem',
    _hidden: false,
  },
  {
    id: -4,
    title: '手机号码',
    type: 'Field::TextField',
    _hidden: false,
  },
  {
    id: -16,
    title: '成员标签',
    type: 'Field::Tags',
    _hidden: false,
  },
  {
    id: -17,
    title: '所在组织',
    type: 'Field::Organization',
    _hidden: false,
  },
];

export default Vue.extend({
  components: {
    'members-table': MembersTable,
    'user-organization-container': UserOrganizationsContainer,
    'organizations-content': OrganizationsContent,
  },

  props: {
    membersCount: {
      type: Number,
    },
    bindedMembersCount: {
      type: Number,
    },
    resourceUrl: {
      type: String,
      required: true,
    },
    query: {
      type: String,
    },
    action: {
      type: String,
    },
    fieldable: {
      type: Object,
    },
    profileSchema: {
      type: Object,
    },
  },

  data() {
    return {
      datableGID: new Skylark.Libs.GlobalID('gid://skylark/Organization/-1'),
      selectedRows: [],
      dataCount: '',
    };
  },

  computed: {
    tableTitle() {
      if (this.query) return `相关成员 · ${this.dataCount}`;
      return '全部成员';
    },

    speacialFields() {
      if (this.action === 'members') return SPEACIAL_FIELDS;
      return undefined;
    },
  },

  template: `
    <user-organization-container :title="tableTitle">
      <template slot="content">
        <members-table :fieldable="fieldable"
                       :datableGID="datableGID"
                       :resourceUrl="resourceUrl"
                       :deleteMemberOperation='false'
                       :speacialFields='speacialFields'
                       @recordsChanged="recordsChanged"
                       ref="membersTableRef">
            <template slot="datable-table-summary" slot-scope='{ selectedRows }'>
              <organizations-content :actionOptions="['new', 'import', 'export', 'tags']"
                                     v-if="!query"
                                     :bindedMembersCount="bindedMembersCount"
                                     :membersCount="membersCount"
                                     :profileSchema="profileSchema"
                                     :selectedRows='selectedRows'
                                     :refreshDataAfterOperation='refreshDataAfterOperationFunc'
                                     @refreshSeletedRowsTags='refreshSeletedRowsTags' />
            </template>
        </members-table>
      </template>
    </user-organization-container>
  `,

  methods: {
    refreshDataAfterOperationFunc() {
      this.$refs.membersTableRef.refreshData();
    },

    refreshSeletedRowsTags(updateTagsOptions) {
      this.$refs.membersTableRef.refreshSeletedRowsTags(updateTagsOptions);
      this.$refs.membersTableRef.resetTableAllSelected();
    },

    recordsChanged(count) {
      this.dataCount = count;
    },
  },
});
